import * as React from "react";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import "../templates/singleBlog.module.css";
import { blogtitle, rssicon } from "./layout.module.css";

const Layout = ({ pageTitle, children }) => {
  return (
    <div>
      <header>
        <Link to="/" className={blogtitle}>
          {" "}
          mouii.net
        </Link>
        <a
          href="https://mouii.net/rss.xml"
          className={rssicon}
          target="_blank"
          rel="noreferrer"
        >
          <img
            className={rssicon}
            alt="RSS"
            src="/images/rss.svg"
            style={{ fill: "#79c0ff" }}
          />
        </a>
      </header>
      <nav></nav>
      <main>
        <h5>{pageTitle}</h5>
        {children}
      </main>
    </div>
  );
};

export default Layout;
